/* eslint-disable no-extend-native */
import "core-js/features/array/find";
import "core-js/features/string/ends-with";
import "core-js/features/string/starts-with";
import "core-js/features/number/is-nan";
import "core-js/features/object/is";
import "core-js/features/array/flat-map";
import { format } from "date-fns";
import { polyfill } from "seamless-scroll-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

import "./components/elements/BaseButton.css";
import "./stylesheets/light/light.scss";
import "./stylesheets/reboot.css";
import "./stylesheets/main.css";

// Registers the iframe-resizer content-window script (side-effect import).
import "iframe-resizer/js/iframeResizer.contentWindow";

polyfill();

// Because server uses local ISO dates
Date.prototype.toISOString = function toLocalISOString() {
  return format(this, "yyyy-MM-dd'T'HH:mm:ss");
};

// render the main component
const appContainer = window.bookingAppContainer || document.getElementById('bokamera-embedded');

const render = (Component: React.ComponentType) =>
  ReactDOM.render(
    <>
      <Component />
      <div style={{ clear: 'both' }} data-iframe-height></div>
    </>,
    appContainer
  );

render(App);

// @ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
